import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordAuthenticationPoliciesModalComponent } from './password-authentication-policies-modal.component';
import { ButtonModule, ToggleModule, CheckboxModule, RadioModule, DropdownModule } from '@xref/xref-lib';

@NgModule({
  declarations: [PasswordAuthenticationPoliciesModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ToggleModule,
    CheckboxModule,
    RadioModule,
    DropdownModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [PasswordAuthenticationPoliciesModalComponent]
})
export class PasswordAuthenticationPoliciesModalModule { }

